<template>
  <div class="page">
    <TipsHbrb ref="child"></TipsHbrb>
    <PageLoading v-if="loading"></PageLoading>
    <div class="topBanner">
      <img src="@/assets/images/blind/topImg.png" alt="">
    </div>
    <div class="moreBtn" @click="showPageLink">更多资讯</div>
    <div class="actNote" @click="showNoticePup">活动说明</div>
   
    <div class="blindBox">
      <img class="hand" src="@/assets/images/blind/hand.gif" alt="" v-if="!showOpen" @click="startDraw">
      <img class="unopen" src="@/assets/images/blind/prize_un.png" alt="" v-if="!showOpen" @click="startDraw">     
      
      <img class="open" src="@/assets/images/blind/prize_open.gif" alt="" v-if="showOpen">
    </div>
    <navBar></navBar>  

    <!-- 活动规则 -->
    <van-popup v-model="showNotice" closeable close-icon="close" round>          
      <div class="noticBox">        
        <h2 class="noticTitle">
          <span class="line"></span>
          <span class="text">活动说明</span>
          <span class="line"></span>
        </h2>
        <div class="noticTxt" v-html="this.actExtend.explain"></div>
      </div>
    </van-popup>

    <!-- 中奖弹窗 0实物奖品、1电子券码、2口令红包、3微信红包、4纵览积分、5日报积分、6手机话费、7实物票券 -->
      <van-popup v-model="winBox" closeable close-icon="close" :class="prize_type ==2 ? 'moneyBox' : 'winBox'">
        <!-- 非口令红包 -->
         <div class="prizeBox" v-if="prizeWin.prize_type!=2">
          <p class="prizeName">{{prizeWin.prize_name}}</p>
          <p class="prizeNote">{{prizeWin.prize_note}}</p>
          <p class="prizeLimit" v-if="prizeWin.limit_get==0 && (prizeWin.prize_type==0 || prizeWin.prize_type==7)">（请领取并填写个人信息）</p>
          <p class="prizeLimit" v-if="prizeWin.limit_get>0 && (prizeWin.prize_type==0 || prizeWin.prize_type==7)">（请中奖后{{ limitGetText }}内领取并填写个人信息，逾期将自动作废）</p>
          <p v-if="prizeWin.sncode && prizeWin.prize_type==1">券码：{{prizeWin.sncode}}</p>
          <div v-if="prizeWin.sncode && prizeWin.prize_type==1" class="copybox" @click="copyTxt">复制券码</div>  
          <p v-if="prizeWin.sncode && prizeWin.prize_type==7">票码：{{prizeWin.sncode}}</p>
          <div v-if="prizeWin.sncode && prizeWin.prize_type==7" class="copybox" @click="copyTxt">复制票码</div>        
         </div>

         <!-- 口令红包 -->
         <div class="MoneyBox" v-if="prizeWin.prize_type==2">
          <p class="prizeName">{{prizeWin.prize_name}}</p>
          <p class="prizeNote">{{prizeWin.prize_note}}</p>
          <p v-if="prizeWin.sncode" class="sncode">红包口令：{{prizeWin.sncode}}</p>
          <div v-if="prizeWin.sncode" class="copybox" @click="copyTxt">复制口令</div>             
         </div>

         <div class="boxBtn">
          <div class="onceMore" @click="closePbox">再次挑战</div>
          <div v-if="prizeWin.prize_type==0 || prizeWin.prize_type==6 || prizeWin.prize_type==7" class="getPrize" @click="getPrize">领取奖品</div>
          <div v-else class="backHome" @click="closePbox">关闭窗口</div>
         </div>
      </van-popup>       

      <!-- 未中奖弹窗 -->
      <van-popup v-model="failBox" closeable close-icon="close" class="failBox">
         <div class="prizeBox">
            <p class="prizeName">{{prizeWin.prize_name}}</p>
         </div>
         <div class="boxBtn">
          <div class="onceMore" @click="closePbox">再次挑战</div>
          <div class="backHome" @click="closePbox">关闭窗口</div>
         </div>
      </van-popup>

      <van-popup v-model="infoBox" closeable close-icon="close" class="infoBox">
        <van-form @submit="onSubmit">
          <van-field
            v-model="contactData.contact_name"
            name="contact_name"
            label="姓名"
            placeholder="真实姓名"
            :rules="[{ required: true, message: '请填写真实姓名' }]"
          />
          
          <van-field
            v-model="contactData.contact_phone"
            name="contact_phone"
            label="手机号"
            placeholder="手机号"
            :rules="[{ required: true, message: '请填写手机号' }]"
          />
          <van-field
            readonly
            clickable
            name="picker"
            :value="contactData.contact_phone_type"
            label="运营商"
            placeholder="手机运营商"
            @click="showPicker = true"
            v-show="prize_type==6"
          />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              @confirm="onConfirm"
              @cancel="showPicker = false"
              v-show="prize_type==6"
            />
          </van-popup>
          <!-- <van-field   
            v-model="contactData.contact_company"
            name="contact_company"
            label="单位名称"
            placeholder="单位名称"
            :rules="[{ message: '请填写单位名称' }]"
          /> -->
          <van-field
            v-show="prize_type==0 || prize_type==7"
            v-model="contactData.contact_address"
            name="contact_address"
            label="邮寄地址"
            placeholder="邮寄地址"
            :rules="[{ message: '请填写邮寄地址' }]"
          />
          <input type="hidden" name="recordid" v-model="prizeWin.recordid">
          <div style="margin: 16px;">
            <van-button round block type="danger" native-type="submit">确认</van-button>
          </div>
        </van-form>      
      </van-popup>
      <!-- 1电脑端，2微信端，3纵览新闻客户端，4河北日报客户端，5H5端 -->
      <stat :actId="actInfo.lotteryid" :actTitle="actInfo.title" :from="4" v-if="actInfo && actInfo.lotteryid"></stat>
  </div>
</template>

<script>

//纵览顶部提示栏及唤起app
import TipsHbrb from '@/components/TipsHbrb.vue'
import PageLoading from '@/components/PageLoading.vue'
import navBar from '@/components/navBar.vue'
import stat from '@/components/stat.vue'
import {reqWxAuthorize} from '@/api/index.js'
import {reqDraw, reqLotteryExtend, reqSubMyinfo } from '@/api/lotteryHbrb.js'
import Cookies from 'js-cookie'
import {isWeixin,wxAuthorize, removeQueryParam} from "@/utils/wx-authorize.js" //微信授权
//分享
import { wxShare } from '@/utils/wxshare-wes2.com.js'
import { Dialog } from 'vant';
import { Clipboard } from "v-clipboard";
export default {
  name: 'index',
  components: {
    TipsHbrb, PageLoading, navBar, stat
  },
  data () {
    return {
      loading: true,
      lotteryid:0,
      token:"",
      accessid:'', 
      openid:'', //微信用户openid   
      accountId: '',
      uniqueId: '',
      title:"",       
      actInfo:{},   
      actExtend:{},
      showNotice:false,
      shareImg:"https://img2.hebnews.cn/img/home.53fe0d7.png",
      shareTitle:"",
      shareDesc:"", 
      currDis:0,
      showOpen:false,
      //抽奖结果窗口参数
      winBox: false,
      failBox: false,
      prizeWin:{
        prizeid:0,
        prize_index:0,
        prize_name:'感谢参与！',
        prize_note:'',
        prize_img:'',
        prize_type:null,
        sncode:'',
        recordid:0,
        todayNums:0
      },
      sncode:"",
      //提交信息参数
      infoBox: false,
      prize_type:0,
      recordid:'',
      contactData:{},
      nickname: '',
      phone: '',
      address: '',
      contact_others: '',
      columns: ['中国移动', '中国电信', '中国联通', '中国广电', '其它'],
      showPicker: false,
    }
  },  
  created (){
      this.lotteryid = this.$route.query.lotteryid;
      this.cateid = this.$route.query.cateid;
      this.token = this.$store.state.token;
      this.accountId = this.$store.state.accountId;
      this.uniqueId = this.$store.state.uniqueId;
      this.actInfo = this.$store.state.actInfo;
      this.shareImg = this.$store.state.actInfo.share_logo;
      this.shareTitle = this.$store.state.actInfo.share_title;
      this.shareDesc = this.$store.state.actInfo.share_desc;
      if(this.actInfo.is_cate == 1) {
        if(!this.cateid) {
          this.$toast({
            icon: 'warning-o',
            message: '请先选择盲盒类别'
          });
          return false;
        }
      }
      if(this.lotteryid) {
        this.loading = false;
      } else {
        this.$toast({
          icon: 'warning-o',
          message: '活动不存在'
        });
      }
  },
  mounted () {
    
  },  
  computed: {
    limitGetText() {
      const h = this.prizeWin.limit_get || 0;
      if (h > 72) {
        const days = Math.floor(h / 24);
        const hours = h % 24;
        return hours > 0 ? `${days}天${hours}小时` : `${days}天`;
      }
      return `${h}小时`;
    },
  },
  methods: {
    startDraw(){
      let params = {
        lotteryid:this.lotteryid, 
        cateid:this.cateid , 
        hbrb_account_id:this.accountId,
        hbrb_unique_id:this.uniqueId
      }
      reqDraw(params).then(res => {       
        
        if(res.code==200) {   
          if(res.data.flag=="success") { 
            this.showOpen = true; 
            if(res.data.prizeid>0) { //中奖
              this.winBox = true;
              this.showOpen = false;
              this.prizeWin = res.data;
              this.recordid = res.data.recordid;
              //中奖填写信息是否包含联系地址 
              // prize_type 奖品分类，0实物奖品、1电子券码、2口令红包、3微信红包、4纵览积分、5日报积分、6手机话费
              if(this.prizeWin.prize_type==0) {
                this.showAddress = true;
              } else {
                this.showAddress = false;
              }
              
            } else { //未中奖
              let that = this;
              setTimeout(() => {
                console.log('==');                
                that.failBox = true;
                that.showOpen = false;
              }, 1000);
            }
          } else {
            let that = this;
            setTimeout(() => {      
              that.showOpen = false;
            }, 1000);

            this.$toast({
                icon: 'warning-o',
                message: res.data.message
            });
          }
          
             
  
        } else {
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {        
        this.$toast({
            icon: 'warning-o',
            message: err
        });
      }) 
    },
    handleClick(){
      this.showOpen = !this.showOpen;
      setTimeout(() => {
        this.failBox = true;
        this.showOpen = false;
      }, 1000);
    },
    showPageLink(){
      window.location.href = "https://hbxw.hebnews.cn/subject.html?id=618726&template=0";    
    },
    showNoticePup() {      
      this.actExtend = this.$store.state.actExtend;
      if(!this.actExtend) {
        this.showNotice = true;
      } else {
        this.loading = true;
        reqLotteryExtend({lotteryid:this.lotteryid}).then(res => {        
          if(res.code==200) {       
            this.loading = false;
            this.actExtend = res.data;   
            this.$store.commit("SET_ACTEXTEND",res.data); 
            this.showNotice = true;
          } else {
            this.loading = false;
            this.$toast({
                icon: 'warning-o',
                message: res.msg
            });
          }
        }).catch(err => {     
          this.loading = false;   
          this.$toast({
              icon: 'warning-o',
              message: err
          });
        }) 
      }
    },
    setCurr(curr){
      this.currDis = (curr==0) ? 0 :1
    },
    openBox(index) {
      if (this.activeBox === index) {
        this.activeBox = -1
        void this.$el.offsetHeight // 强制回流，重置动画
        this.activeBox = index
        return
      }
      this.activeBox = index
    },
    onConfirm(value, index) {
        this.contactData.contact_phone_type = value;
        this.showPicker = false;
    },
    // 复制成功回调函数
    copyTxt() {
      Clipboard.copy(this.sncode);
      this.$toast({
        icon: 'success',
        message: '复制成功'
      }); 
    },
    closePbox() {
      this.winBox = false;
      this.failBox = false;
      // this.$refs.myLucky.init();
    },
    getPrize() {
      this.winBox = false;
      this.failBox = false;
      this.infoBox = true;      
    },
    async onSubmit() {
      let data = {};
      data = {...this.contactData,lotteryid:this.lotteryid, recordid:this.recordid?this.recordid:this.prizeWin.recordid,  hbrb_account_id:this.accountId, hbrb_unique_id:this.uniqueId};

      console.log('reqSubMyinfo',data);
      let result = await reqSubMyinfo(data);
      if(result.code==200) {
        this.infoBox = false;
        this.recordid = result.data.recordid;
        this.contactData = result.data;

        this.$toast({
          icon: 'success',
          message: result.msg
        });    
      } else {
        this.$toast({
          icon: 'warning-o',
          message: result.msg
        });
      }
    },
    toHome(){
      this.$router.push({ path: '/index',query:this.$route.query })
    },    
    toLucky(){
      this.$router.push({ path: '/lottery',query:this.$route.query })
    },
    toMyPrize(){
      this.$router.push({ path: '/myprize',query:this.$route.query })
    },
  
  }
  
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/blind.scss';
</style>